<div id="map"
  [ngClass]="{'leaflet-map-mini': styleType === 'mini', 'leaflet-map-full': styleType === 'full', 'leaflet-map-default': styleType === 'default', 'leaflet-map-geotrace': styleType === 'geotrace' , 'border': popOver}">
</div>
